<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Vendas por categoria (Top 10)
    </v-card-title>
    <figure style="width: 100%;" v-show="dataPoints && dataPoints.length">
      <v-chart :options="chart"
               ref="vendasCategoriaChart"
               autoresize/>
    </figure>
    <v-card-text v-if="!dataPoints || !dataPoints.length"
                 class="text--primary chart-empty-div d-flex align-center justify-center">
      <span class="font-weight-bold">
        Nenhum dado encontrado para o período
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { colorPallete } from '@/plugins/echarts/echarts-colors';
import IndicadoresMarketplaceService from './indicadores-marketplace';

export default {
  mixins: [chartMixin],
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vendasCategorias: null,
      dataPoints: [],
      chart: null,
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.stateDate.initialDate} and dataCompra <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    showLoading() {
      this.$refs.vendasCategoriaChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      this.$refs.vendasCategoriaChart.hideLoading();
    },
    buildChart(data) {
      return {
        width: '80%',
        tooltip: {
          trigger: 'item',
          formatter: this.tooltipPieFormatter,
        },
        legend: {
          orient: 'vertical',
          left: '15px',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            center: ['75%', '50%'],
            color: colorPallete,
            label: {
              show: false,
            },
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    buildChartData(data) {
      const chartData = Object.keys(data).map((key) => ({
        name: key,
        value: data[key],
      }));
      this.dataPoints = chartData;
      this.chart = this.buildChart(chartData);
    },
    getComprasPorDia() {
      this.showLoading();
      IndicadoresMarketplaceService.getComprasPorCategoria({
        query: this.query,
      })
        .then(({ data }) => {
          this.vendasCategorias = data;
          this.buildChartData(this.vendasCategorias);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComprasPorDia();
    },
  },
  mounted() {
    this.getComprasPorDia();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}

.chart-empty-div {
  height: 280px;
}
</style>
